const icon = require('vue-svgicon');
icon.register({
    'eye': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9 15.002c4.418 0 8-6 8-6V9s-3.582-6-8-6-8 6-8 6v.001s3.582 6 8 6zM2.19 8.995C3.379 7.236 6.152 4.001 9 4.001c3.098 0 5.878 3.642 6.81 5.006C14.62 10.767 11.847 14 9 14c-3.098 0-5.878-3.641-6.81-5.005zM9 13a4 4 0 110-8 4 4 0 010 8zM6 9a3 3 0 116 0 3 3 0 01-6 0z" _fill="#000"/>`,
    },
});
